import { ClockIcon, GlobeAltIcon, PhoneIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { dayInLong, rangeIn, zoneLabel } from '../../sales/shared/calendar.helpers';

export interface WhenWhereProps {
    title: string;
    startIso: string;
    endIso: string;
    timeZone: string;
    /** A Meet link, or null for a phone call. `undefined` hides the row (not known yet). */
    meetLink?: string | null;
    location?: 'meet' | 'phone';
}

// #region WhenWhere
/** The one block that repeats on every screen: what, when, where. */
export const WhenWhere: React.FunctionComponent<WhenWhereProps> = ({ title, startIso, endIso, timeZone, meetLink, location }): React.ReactElement => (
    <dl className="flex flex-col gap-y-2 text-sm">
        <div className="text-base font-semibold text-zinc-900 dark:text-zinc-100">{title}</div>
        <div className="flex items-start gap-x-2 text-zinc-700 dark:text-zinc-300">
            <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-zinc-400" />
            <div>
                <div>{dayInLong(startIso, timeZone)}</div>
                <div className="tabular-nums">{rangeIn(startIso, endIso, timeZone)}</div>
            </div>
        </div>
        <div className="flex items-center gap-x-2 text-zinc-700 dark:text-zinc-300">
            <GlobeAltIcon className="h-4 w-4 shrink-0 text-zinc-400" />
            <span>{zoneLabel(timeZone, new Date(startIso))}</span>
        </div>
        {meetLink !== undefined || location ? (
            <div className="flex items-center gap-x-2 text-zinc-700 dark:text-zinc-300">
                {meetLink || location === 'meet' ? <VideoCameraIcon className="h-4 w-4 shrink-0 text-zinc-400" /> : <PhoneIcon className="h-4 w-4 shrink-0 text-zinc-400" />}
                {meetLink ? (
                    <a href={meetLink} target="_blank" rel="noreferrer" className="text-emerald-700 dark:text-emerald-400 underline underline-offset-2 break-all">Google Meet</a>
                ) : (
                    <span>{location === 'meet' ? 'Google Meet — link arrives with the invitation' : 'By phone'}</span>
                )}
            </div>
        ) : null}
    </dl>
);
